import { createMasterDataCrudApi } from "./entityApiShared.js";
import type { CrudApi, EntityCreateRequest, EntityRecord, EntityUpdateRequest } from "../types/api.types.js";

export type ComplaintsourceDto = EntityRecord;
export type ComplaintsourceCreateRequest = EntityCreateRequest;
export type ComplaintsourceUpdateRequest = EntityUpdateRequest;

export const complaintSourceApi: CrudApi<ComplaintsourceDto, ComplaintsourceCreateRequest, ComplaintsourceUpdateRequest> = createMasterDataCrudApi({ masterType: "complaint-source" });
